var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMutualEmptyState(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "56px",
    viewBox: "0 0 60 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMutualEmptyState") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.80858191,20.2442161 C6.01554325,17.9520063 8.91728698,16.8043478 11.8229619,16.8043478 C14.7286367,16.8043478 17.6449818,17.952011 19.85199,20.2442161 L22.4990519,23.0019164 L25.1461607,20.2587303 C29.5601302,15.6742225 36.7756002,15.6743247 41.1895229,20.2587303 C45.6034924,24.8431406 45.6034924,32.2059984 41.1895229,36.7904133 C35.1826925,43.0292487 29.1785755,49.2750509 23.1717919,55.5137469 C22.9949856,55.6992481 22.7490398,55.8043478 22.4917512,55.8043478 C22.2344626,55.8043478 21.9885169,55.6992481 21.8117106,55.5137469 L3.80858191,36.7758759 C-0.600333112,32.1879125 -0.605387436,24.8285521 3.80858191,20.2442161 Z M41.9287058,2.30377759 C42.8817119,1.30460922 44.1347376,0.804347826 45.3894608,0.804347826 C46.644184,0.804347826 47.9035149,1.30461124 48.8565411,2.30377759 L49.9995906,3.50585208 L51.1426603,2.3101043 C53.0486926,0.311729095 56.1644637,0.311773635 58.0704758,2.3101043 C59.9765081,4.30843698 59.9765081,7.51788781 58.0704758,9.51622252 C55.4766172,12.2357149 52.8839303,14.958244 50.2900919,17.6776756 C50.2137438,17.7585351 50.1075399,17.8043478 49.996438,17.8043478 C49.8853361,17.8043478 49.7791323,17.7585351 49.7027841,17.6776756 L41.9287058,9.50988568 C40.0248562,7.51000422 40.0226736,4.30207788 41.9287058,2.30377759 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PopuP---No-mutual-matches",
    transform: "translate(-158.000000, -132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/MutualMatch_New-Copy",
    transform: "translate(148.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icMutualEmptyState",
    fillOpacity: 0.6,
    fill: "#666666",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMutualEmptyState);
export default __webpack_public_path__ + "static/media/icMutualEmptyState.637b9bd34fbff5490e56c111108331fb.svg";
export { ForwardRef as ReactComponent };